"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Escape = exports.unescapeXML = exports.escapeXML = void 0;
var XML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&apos;'
};
var XML_UNESCAPE_MAP = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\''
};
var TO_ESCAPE = /[&<>"']/g;
var TO_UNESCAPE = /&(?:amp|lt|gt|quot|apos);/g;
var doEscape = function (ch) { return XML_ESCAPE_MAP[ch]; };
var doUnEscape = function (ch) { return XML_UNESCAPE_MAP[ch]; };
var escapeXML = function (s) { return s.replace(TO_ESCAPE, doEscape); };
exports.escapeXML = escapeXML;
var unescapeXML = function (s) { return s.replace(TO_UNESCAPE, doUnEscape); };
exports.unescapeXML = unescapeXML;
exports.Escape = {
    escape: exports.escapeXML,
    unescape: exports.unescapeXML
};
//# sourceMappingURL=escape.xml.js.map